import { Export } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useAudienceMutations from "../../../../datahooks/useAudienceMutations";

import type { AudienceFilters } from "../../../../types";

interface ExportAudienceProps {
  filters: AudienceFilters;
  isMiningTargets: boolean;
  allAudienceCount: number;
}

export default function ExportAllAudience({
  filters,
  isMiningTargets,
  allAudienceCount,
}: ExportAudienceProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { exportAudience, isExporting } = useAudienceMutations();

  const [exportUrl, setExportUrl] = useState<string>();

  const handleExportAudience = async () => {
    // Get the export URL
    const url = await exportAudience(filters);

    // Set the export URL
    setExportUrl(url);
  };

  const isDisabled = !allAudienceCount || isMiningTargets;

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Component open={!!exportUrl} onOpenChange={() => setExportUrl(null)}>
        <Content>
          <Header
            title="Your export is ready"
            subtitle="Click the button below to download your export in CSV format"
          />

          <Footer className="justify-end">
            <Button
              onClick={() => {
                window.open(exportUrl);
                setExportUrl(null);
              }}
            >
              Download
            </Button>
          </Footer>
        </Content>
      </Component>

      <Button
        size={isDesktop ? "sm" : "md"}
        className="max-lg:ml-auto"
        variant="secondary-purple"
        leftIcon={<Export weight="fill" />}
        disabled={isDisabled}
        isLoading={isExporting}
        onClick={handleExportAudience}
      >
        Export audience
        {!isDisabled && (
          <span className="max-lg:hidden"> ({allAudienceCount})</span>
        )}
      </Button>
    </>
  );
}
